import React from "react";
import {ObservationView} from "./ObservationView";
import {PencilAddNoteIcon} from "../widgets/CustomIcons";


export const QuestionaireTable = ({dossier, currentRound, healthOverviewState, healthOverviewDispatch}) => {


    const renderRow = row => {

        const rowHasObservations = () => {
            for (let vo of row.roundObservations) {
                if(vo.observations) {
                    return true
                }
            }

            if(row.roundNotes) {
                for(const rn of row.roundNotes) {
                    if(rn.note) {
                        return true
                    }
                }
            }
        }

        if (row.type === 'SelectedObservationTypePanel') {
            return <ObservationView
                    row={row}
                    dossier={dossier}
                    currentRound={currentRound}
                    healthOverviewDispatch={healthOverviewDispatch}
                />
        }
        else {

            const openCloseIcon = () =>
                <span className={"text-1xl font-bold ml-1"}>
                    {row.isCategory && (row.isVisibleCategory ? "-" : "+")}
                </span>


            const renderCategorySummary = () => {
                if(!row.isCategory || row.observationCount === 0) {
                    return null
                }

                return `(${row.observationCount})`
            }

            const renderLabel = () => {
                if(row.level0Label === "Comorbidités") {
                    return `${row.level1Label} - ${row.label}`
                }
                else if(row.level0Label === "Antécédents") {

                    if(row.level1Label === ".") {
                        return row.label
                    }

                    return `${row.level1Label} - ${row.label}`
                }
                return row.label
            }

            return <><td
                    key={`c1`}
                    className={"px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"}
                    style={{
                        borderRight: "solid 1px #E5E7EB",
                        minWidth: 1000
                }}
                >
                    <div style={{marginLeft: `${(row.depth -2) * 2}rem`}}>
                        <div
                            style={{cursor: 'pointer'}}
                            onClick={() => {

                                if (row.isCategory) {
                                    healthOverviewDispatch({
                                        name: "toggleVisibleCategory",
                                        categoryId: row.o.id
                                    })
                                }
                                else {
                                    healthOverviewDispatch({
                                        name: "selectObservationType",
                                        observation_type_id: row.o.id
                                    })
                                }
                            }}
                        >{renderLabel()} {renderCategorySummary()} {openCloseIcon()}
                        </div>
                    </div>
                </td>
                <td>
                    {rowHasObservations() ? <PencilAddNoteIcon/> : null}
                </td>
            </>
        }
    }

    return <div className="relative shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead>
            <tr>
                <th></th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {healthOverviewState.rows.map(row =>
                <tr
                    key={`tr-${row.label}-${row.o.id}`}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                    {renderRow(row)}
                </tr>
            )}
            </tbody>
        </table>
    </div>
}